import { useState, useEffect } from 'react';

export const AUTH_LIBRARY_THEME_KEY = 'easeverse_auth_library_theme';

/**
 * Shared theme state for Auth and Library pages (Light / Dark Mode).
 * Syncs with localStorage and sets data-auth-library-theme on <html>.
 * @returns {{ theme: 'light'|'dark', toggleTheme: () => void }}
 */
export function useAuthLibraryTheme() {
  const [theme, setTheme] = useState(() => {
    try {
      return localStorage.getItem(AUTH_LIBRARY_THEME_KEY) || 'light';
    } catch {
      return 'light';
    }
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-auth-library-theme', theme);
    return () => document.documentElement.removeAttribute('data-auth-library-theme');
  }, [theme]);

  const toggleTheme = () => {
    const next = theme === 'light' ? 'dark' : 'light';
    setTheme(next);
    try {
      localStorage.setItem(AUTH_LIBRARY_THEME_KEY, next);
    } catch (_) {}
  };

  return { theme, toggleTheme };
}
